import React from "react";

interface EditIconProps {
  color?: string;
  size?: number;
}

export const EditIcon: React.FC<EditIconProps> = ({
  color = "#0056D6",
  size = 12,
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.5 21.5L8.04927 19.3657C8.40421 19.2291 8.58168 19.1608 8.74772 19.0719C8.8952 18.9929 9.0358 18.9023 9.16804 18.8012C9.31692 18.6872 9.45137 18.5527 9.72028 18.2838L21 7C22.1046 5.89543 22.1046 4.10457 21 3C19.8954 1.89543 18.1046 1.89543 17 3L5.72028 14.2797C5.45138 14.5486 5.31692 14.6831 5.20295 14.832C5.10181 14.9642 5.01118 15.1048 4.93218 15.2523C4.84322 15.4183 4.77494 15.5958 4.63838 15.9507L2.5 21.5ZM2.5 21.5L4.55812 16.1295C4.70415 15.7504 4.77716 15.5608 4.90355 15.4716C5.01423 15.3935 5.14983 15.3589 5.28381 15.3744C5.43651 15.392 5.58754 15.5117 5.88962 15.7511L8.24889 17.6104C8.5510 17.8497 8.70205 17.9694 8.74862 18.1187C8.78934 18.2494 8.78129 18.3907 8.72594 18.5162C8.66289 18.6592 8.49857 18.7597 8.16993 18.9607L2.5 21.5Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
